import { useState } from "react";
import { SERVERS, resolveServers, probe } from "../../lib/servers";
import { CustomServerFields } from "./CustomServerFields";

const SLOTS = ["Primary", "Failover 1", "Failover 2"];

export const ServerPriorityFields = ({ form, setForm }) => {
  const [checks, setChecks] = useState({});
  const prio = form.server_priority?.length ? form.server_priority : ["cloudflare", "app"];
  const setSlot = (i, id) => {
    const next = [...prio];
    if (id) next[i] = id; else next.splice(i);
    setForm({ ...form, server_priority: next.filter((v, k, a) => v && a.indexOf(v) === k).slice(0, 3) });
    setChecks({});
  };
  const testAll = async () => {
    const list = resolveServers({ ...form, server_priority: prio });
    setChecks(Object.fromEntries(list.map((s) => [s.id, "…"])));
    for (const s of list) {
      try { const ms = await probe(s.target); setChecks((c) => ({ ...c, [s.id]: `${ms} ms` })); }
      catch { setChecks((c) => ({ ...c, [s.id]: "unreachable" })); }
    }
  };

  return (
    <div className="mt-2 space-y-2" data-testid="server-priority-fields">
      <span className="label">Test servers (priority & failover)</span>
      {SLOTS.map((label, i) => {
        if (i > prio.length) return null;
        const val = prio[i] || "";
        const chk = checks[val];
        return (
          <div key={label} className="flex items-center gap-2">
            <span className="w-20 shrink-0 text-[10px] text-neutral-500 uppercase tracking-wider">{label}</span>
            <select data-testid={`server-priority-${i}`} value={val} onChange={(e) => setSlot(i, e.target.value)} className="field flex-1 py-2 text-xs">
              {i > 0 && <option value="">None</option>}
              {SERVERS.map((s) => <option key={s.id} value={s.id} disabled={prio.includes(s.id) && s.id !== val}>{s.name}</option>)}
            </select>
            {chk && <span className={`w-20 text-right text-[10px] ${chk === "unreachable" ? "text-[#FF3B30]" : "text-[#32D74B]"}`} data-testid={`server-check-${i}`}>{chk}</span>}
          </div>
        );
      })}
      {prio.includes("custom") && <CustomServerFields form={form} setForm={setForm} />}
      <div className="flex items-center gap-3">
        <button type="button" data-testid="test-servers-button" onClick={testAll} className="btn-ghost text-xs">Test servers</button>
        <span className="text-[10px] text-neutral-600">Each test uses the first reachable server; if it fails mid-test the next one takes over. Applies to new tests.</span>
      </div>
    </div>
  );
};
